<template>
  <div id="homePage-4" v-if="imgs&&imgs.length">
      <div class="imgs-content">
        <div v-for="(imgitem,index) in imgs" v-bind:key="index">
          <img v-if="imgitem.img" :src="require('../../../assets/img/'+imgitem.img)" />
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'PageFour',
  data () {
    return {
      // imgs:[
      //   {
      //     img:"https://cos.dhfapp.com/goimg/73dcfb86-b681-4782-b3cf-d9cc12275230.jpg"
      //   },
      //   {
      //     img:"https://cos.dhfapp.com/goimg/57be25de-2142-4910-9974-fe2763eabfb2.jpg"
      //   },
      //   {
      //     img:"https://cos.dhfapp.com/goimg/6e58e23c-b785-4140-922c-cd49257aa1de.jpg"
      //   },
      //   {
      //     img:"https://cos.dhfapp.com/goimg/9f1869c8-3602-43d9-9dce-5cf534cc9375.jpg"
      //   }
      // ]
    }
  },
  created () {
    // ...
    if(this.configData){
      this.imgs=this.configData.page4Imgs
    }
  }
}
</script>
<style lang="scss" scoped>
  .imgs-content{
    display: flex;
    width:100%;
    div{
      flex:1;
      img{
        width:100%;
      }
    }
    
  }
</style>
